import { createType } from 'framework/utils/createType';

export const ProductCatalogItemDetailTabTypes = createType('overview', 'transactions', 'inventoryItems', 'comments');
export type ProductCatalogItemDetailTabType = typeof ProductCatalogItemDetailTabTypes[number];
